import script from "./CalendarioView.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarioView.vue?vue&type=script&setup=true&lang=js"

import "./CalendarioView.vue?vue&type=style&index=0&id=9f395e24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f395e24"]])

export default __exports__